import { useGetUserQuery } from '@/affiliate-dashboard/graphql';
import { Skeleton } from '@/components/base/skeleton';
import invariant from 'tiny-invariant';
import { Overview } from './components/overview';

export function PromoterDetail({ userId }: { userId: string }): JSX.Element {
  const { data, loading } = useGetUserQuery({
    variables: { searchString: userId },
  });
  if (loading) {
    return (
      <div className="h-40 w-full">
        <Skeleton className="h-full w-full rounded-2xl" />
      </div>
    );
  }

  invariant(data?.user, `[${userId}] User detail missing`);

  return <Overview data={data?.user} />;
}
